import type { LogRecord, LogFormatter } from '@wkda/logger-core';

import type { EcsLog } from './interfaces/log-ecs.interface.js';

interface ECSLogFormatterConfig {
  serviceName: string;
}

function getUrlField(logRecord: LogRecord) {
  const original = logRecord.request?.url;
  const domain = logRecord.request?.domain;
  if (!original || !domain) return;

  return { original, domain };
}

function getHttpField(logRecord: LogRecord) {
  if (!logRecord.request) return;

  return {
    'request.referrer': logRecord.request.referrer,
    'request.method': logRecord.request.method,
    'response.status_code': logRecord.request.statusCode,
  };
}

export class EcsLogFormatter implements LogFormatter<EcsLog> {
  constructor(private config: ECSLogFormatterConfig) {}

  format(logRecord: LogRecord): EcsLog {
    return {
      '@timestamp': logRecord.timestamp,
      'service': {
        name: this.config.serviceName,
      },
      'message': logRecord.message,
      'log': {
        ...(logRecord.logLevel && { level: logRecord.logLevel }),
        logger: logRecord.logger,
      },
      'user_agent':
        logRecord.userAgent !== undefined
          ? {
              original: logRecord.userAgent,
            }
          : undefined,
      'event':
        logRecord.duration !== undefined
          ? {
              duration: logRecord.duration,
            }
          : undefined,
      'transaction':
        logRecord.transactionId !== undefined
          ? {
              id: logRecord.transactionId,
            }
          : undefined,
      'trace':
        logRecord.traceId !== undefined
          ? {
              id: logRecord.traceId,
            }
          : undefined,
      'url': getUrlField(logRecord),
      'http': getHttpField(logRecord),
      'source':
        logRecord.ip !== undefined
          ? {
              ip: logRecord.ip,
            }
          : undefined,
      'error': logRecord.error
        ? {
            message: logRecord.error.message,
            stack_trace: logRecord.error.stackTrace,
          }
        : undefined,
      'labels': logRecord.meta ? logRecord.meta : undefined,
    };
  }
}
